// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__4LNwR","pointer":"Button_pointer__iYutf"};